import { normalizeRole as normalizeDepartureRole } from "@features/vessel-call/vessel-call-status/Departure/utils";
import type { TFunction } from "i18next";

export { normalizeDepartureRole as normalizeRole };

export function translateNormalizedRole(t: TFunction, role?: string | null): string {
  const rawRole = role?.trim() ?? "";
  if (!rawRole) return "";

  const normalizedRole = normalizeDepartureRole(rawRole);
  if (!normalizedRole) return rawRole;

  const translationKey = `roles.${normalizedRole}`;
  const translatedRole = t(translationKey);
  const looksRoleLike = /[_-]/.test(rawRole) || rawRole === rawRole.toUpperCase();

  return translatedRole !== translationKey || looksRoleLike ? translatedRole : rawRole;
}
